import React from 'react'
import PropTypes from 'prop-types'
import { FlexByRow, XDivider, HalfScreen, YDivider } from '../../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../../AppControl/RoutePage'
import { ClearButton, SaveButton } from '../../../../irmlib/src/components/FormControls'
import { useSearchParams } from '../../../../irmlib/src/hooks'
import AllOpenJobsData from './AllOpenJobsData'
import * as constants from '../../../../irmlib/src/common/constants'
import JobsFilter from '../JobsFilter'
import { errorToast } from '../../../../common/functions'
import { useTranslation } from 'react-i18next'

const Buttons = props =>
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>

const VerticalDivider = () =>
  <YDivider height='15px' />

Buttons.propTypes = {
  arrRefs: PropTypes.array
}


const AllOpenJobs = (props) => {
  // Get the search param from the path. If the status search param exists then set the initial jobStatus to that param.
  const emptyFilter = { deType: constants.defaultSelect, templateNAme: constants.defaultSelect, jobStatus: constants.defaultSelect, customer: constants.defaultForAccountLevel, orderNumber: constants.defaultForAccountLevel, districts: [constants.defaultSelect], initialStatus: 'APPROVED', userName: constants.defaultSelect, createDateFrom: constants.defaultSelect, createDateTo: constants.defaultSelect }
  const searchParams = useSearchParams()?.get('status')
  const statusNavParam = searchParams || constants.defaultSelect
  const [val, Setval] = React.useState({ ...emptyFilter, jobStatus: statusNavParam, initialStatus: statusNavParam === constants.defaultSelect ? 'NoApprove' : 'APPROVED' })
  // eslint-disable-next-line
  const [FilterApprove, setFilterApprove] = React.useState('NO')
  const { t } = useTranslation()

  const getSelectedDistrict = (data) => {
    if (data.District) {
      if (data.District.length) {
        if (data.District.length > 7) {
          errorToast({ message: t('toast.districtSelection'), title: t('toast.failedToFetch'), autoHideDuration: 3000, isBlocking: false })
        } else {
          Setval({ ...val, districts: data.District })
        }
      } else {
        errorToast({ message: t('toast.invalidDistrict'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
      }
    }
  }

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.jobManagement'
      // subTitle='routeTitles.viewJobs'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <JobsFilter selectedData = {getSelectedDistrict}/>
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
      </FlexByRow>
      <VerticalDivider/>
      <AllOpenJobsData filterData={val} searchParams = {searchParams} />
    </MainRouteSubRoutePage>
  )
}

export default AllOpenJobs
